import React, { Component } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css'
import 'jquery'

// Style
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css'
import "bootstrap/dist/js/bootstrap.bundle.min.js";

// Components
import MainDashboard from './Dashboard/MainDashboard'



class App extends Component {
  componentDidMount(){
    AOS.init();
  }
  
  render(){
    return (
      <React.Fragment>
        <MainDashboard />
      </React.Fragment>
    );
  }
  }


export default App;
